exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searhBarWraper {\n  padding: 0 15px;\n  display: flex;\n  align-items: center; }\n  .searhBarWraper input[type=text] {\n    width: 70%;\n    padding: 10px;\n    margin: 20px auto;\n    border: 3px solid gray;\n    color: #000; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/style/_users.scss
// module id = 1478
// module chunks = 0